export const FogBackground = () => {
  return (
    <>
      {/* Full Moon with passing clouds */}
      <div className="fixed top-8 right-12 pointer-events-none z-0">
        <div className="relative w-24 h-24 md:w-28 md:h-28">
          {/* Outer glow */}
          <div 
            className="absolute -inset-8 blur-3xl opacity-30"
            style={{
              background: 'radial-gradient(circle, hsl(var(--moon)) 0%, transparent 60%)',
            }}
          />
          
          {/* Main moon circle */}
          <div className="absolute inset-0 rounded-full bg-gradient-to-br from-moon via-moon-glow to-moon/85 moon-pulse shadow-lg" />
          
          {/* Crater details */}
          <div className="absolute top-[15%] left-[20%] w-[18%] h-[18%] rounded-full bg-moon-glow/30" />
          <div className="absolute top-[45%] left-[55%] w-[22%] h-[22%] rounded-full bg-moon-glow/25" />
          <div className="absolute top-[65%] left-[25%] w-[14%] h-[14%] rounded-full bg-moon-glow/30" />
          <div className="absolute top-[30%] left-[60%] w-[10%] h-[10%] rounded-full bg-moon-glow/35" />
          <div className="absolute top-[70%] left-[60%] w-[12%] h-[12%] rounded-full bg-moon-glow/20" />
          
          {/* Highlight */}
          <div 
            className="absolute top-[8%] left-[15%] w-[25%] h-[20%] rounded-full bg-white/15 blur-sm"
          />

          {/* Passing clouds */}
          <div className="moon-cloud moon-cloud-1" />
          <div className="moon-cloud moon-cloud-2" />
        </div>
      </div>

      {/* Shooting Stars - varied sizes, across entire screen */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {/* Top area */}
        <div className="shooting-star shooting-star--small" style={{ top: '8%', left: '20%', animationDelay: '5s', animationDuration: '20s' }} />
        <div className="shooting-star shooting-star--medium" style={{ top: '15%', left: '65%', animationDelay: '18s', animationDuration: '25s' }} />
        {/* Middle area */}
        <div className="shooting-star shooting-star--large" style={{ top: '35%', left: '10%', animationDelay: '12s', animationDuration: '22s' }} />
        <div className="shooting-star shooting-star--small" style={{ top: '45%', left: '50%', animationDelay: '28s', animationDuration: '18s' }} />
        <div className="shooting-star shooting-star--medium" style={{ top: '55%', left: '75%', animationDelay: '8s', animationDuration: '24s' }} />
        {/* Bottom area */}
        <div className="shooting-star shooting-star--large" style={{ top: '70%', left: '25%', animationDelay: '35s', animationDuration: '20s' }} />
        <div className="shooting-star shooting-star--small" style={{ top: '80%', left: '60%', animationDelay: '22s', animationDuration: '26s' }} />
      </div>

      {/* Twinkling stars - varied sizes across the entire screen */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {/* Top area */}
        <div className="twinkle-star twinkle-star--small" style={{ top: '8%', left: '15%', animationDelay: '1s', animationDuration: '8s' }} />
        <div className="twinkle-star twinkle-star--large" style={{ top: '12%', left: '55%', animationDelay: '3s', animationDuration: '10s' }} />
        <div className="twinkle-star twinkle-star--medium" style={{ top: '5%', left: '85%', animationDelay: '6s', animationDuration: '9s' }} />
        {/* Middle area */}
        <div className="twinkle-star twinkle-star--large" style={{ top: '35%', left: '25%', animationDelay: '2s', animationDuration: '11s' }} />
        <div className="twinkle-star twinkle-star--small" style={{ top: '42%', left: '70%', animationDelay: '5s', animationDuration: '8s' }} />
        <div className="twinkle-star twinkle-star--medium" style={{ top: '50%', left: '10%', animationDelay: '8s', animationDuration: '10s' }} />
        <div className="twinkle-star twinkle-star--small" style={{ top: '45%', left: '90%', animationDelay: '4s', animationDuration: '9s' }} />
        {/* Bottom area */}
        <div className="twinkle-star twinkle-star--medium" style={{ top: '65%', left: '35%', animationDelay: '7s', animationDuration: '11s' }} />
        <div className="twinkle-star twinkle-star--large" style={{ top: '72%', left: '60%', animationDelay: '2s', animationDuration: '8s' }} />
        <div className="twinkle-star twinkle-star--small" style={{ top: '80%', left: '20%', animationDelay: '9s', animationDuration: '10s' }} />
        <div className="twinkle-star twinkle-star--medium" style={{ top: '85%', left: '75%', animationDelay: '4s', animationDuration: '9s' }} />
        <div className="twinkle-star twinkle-star--large" style={{ top: '92%', left: '45%', animationDelay: '6s', animationDuration: '11s' }} />
      </div>

      {/* Static background stars */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {[...Array(40)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-foreground/20 rounded-full"
            style={{
              width: `${1 + Math.random() * 1.5}px`,
              height: `${1 + Math.random() * 1.5}px`,
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
            }}
          />
        ))}
      </div>
      
      {/* Fog layers */}
      <div className="fog-layer" />
      
      {/* Additional atmospheric gradient */}
      <div 
        className="fixed inset-0 pointer-events-none opacity-40"
        style={{
          background: 'radial-gradient(ellipse at 50% 0%, hsl(222 47% 15% / 0.5) 0%, transparent 70%)',
        }}
      />
    </>
  );
};
